// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-trigger:hover .tooltip {
    opacity: 1;
  }
  
  .tooltip {
    width: max-content;
    max-width: 150px;
    height: 120px; /* Fixed total height */
    background-color: black;
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 8px;
    opacity: 0;
    transition: opacity 1s;
    position: absolute;
    z-index: 1;
    font-family: sans-serif;
    font-size: 14px;
    display: flex;
    flex-direction: column;
  }
  
  .tooltip-header {
    font-weight: bold;
    margin-bottom: 4px;
    flex-shrink: 0;
  }
  
  .tooltip-body {
    font-weight: normal;
    overflow-y: auto;
    flex-grow: 1;
  
    /* Subtle scrollbar styles */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  }
  
  .tooltip-body::-webkit-scrollbar {
    width: 4px;
  }
  
  .tooltip-body::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .tooltip-body::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }
  
  .tooltip-body::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.4);
  }
  
  .tooltip-trigger {
    position: relative;
    display: inline;
  }
  
  /* Tooltip positions */
  .tooltip-right {
    top: -55px;
    left: 200%;
  }
  
  .tooltip-left {
    top: -5px;
    right: 105%;
  }
  
  .tooltip-top {
    bottom: 105%;
    left: 0%;
  }
  
  .tooltip-bottom {
    top: 105%;
    left: 0%;
  }
  
  /* Arrows */
  .tooltip-trigger .tooltip-top::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
  
  .tooltip-trigger .tooltip-bottom::after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }
  
  .tooltip-trigger .tooltip-right::after {
    content: " ";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
  }
  
  .tooltip-trigger .tooltip-left::after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent black;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;IACI,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa,EAAE,uBAAuB;IACtC,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;;IAEZ,4BAA4B;IAC5B,qBAAqB;IACrB,qDAAqD;EACvD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;;EAEA,WAAW;EACX;IACE,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;EACzD;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;EACzD;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;EACzD;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;EACzD","sourcesContent":[".tooltip-trigger:hover .tooltip {\n    opacity: 1;\n  }\n  \n  .tooltip {\n    width: max-content;\n    max-width: 150px;\n    height: 120px; /* Fixed total height */\n    background-color: black;\n    color: #fff;\n    text-align: left;\n    border-radius: 6px;\n    padding: 8px;\n    opacity: 0;\n    transition: opacity 1s;\n    position: absolute;\n    z-index: 1;\n    font-family: sans-serif;\n    font-size: 14px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .tooltip-header {\n    font-weight: bold;\n    margin-bottom: 4px;\n    flex-shrink: 0;\n  }\n  \n  .tooltip-body {\n    font-weight: normal;\n    overflow-y: auto;\n    flex-grow: 1;\n  \n    /* Subtle scrollbar styles */\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n  }\n  \n  .tooltip-body::-webkit-scrollbar {\n    width: 4px;\n  }\n  \n  .tooltip-body::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  .tooltip-body::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n  }\n  \n  .tooltip-body::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n  \n  .tooltip-trigger {\n    position: relative;\n    display: inline;\n  }\n  \n  /* Tooltip positions */\n  .tooltip-right {\n    top: -55px;\n    left: 200%;\n  }\n  \n  .tooltip-left {\n    top: -5px;\n    right: 105%;\n  }\n  \n  .tooltip-top {\n    bottom: 105%;\n    left: 0%;\n  }\n  \n  .tooltip-bottom {\n    top: 105%;\n    left: 0%;\n  }\n  \n  /* Arrows */\n  .tooltip-trigger .tooltip-top::after {\n    content: \" \";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: black transparent transparent transparent;\n  }\n  \n  .tooltip-trigger .tooltip-bottom::after {\n    content: \" \";\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent black transparent;\n  }\n  \n  .tooltip-trigger .tooltip-right::after {\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    right: 100%;\n    margin-top: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent black transparent transparent;\n  }\n  \n  .tooltip-trigger .tooltip-left::after {\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    margin-top: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent transparent black;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
